module.exports = __webpack_public_path__ + "img/linux-adv-03-preview.c0d392f0.jpg";